import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=a5123816&scoped=true"
import script from "./UserSelector.vue?vue&type=script&lang=ts"
export * from "./UserSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5123816",
  null
  
)

export default component.exports